import { Component } from '@angular/core';

@Component({
  selector: 'procure-post-footer',
  templateUrl: './post-footer.component.html',
  styleUrl: './post-footer.component.scss',
})
export class PostFooter {}
